import { render } from "./AddChecklistModel.vue?vue&type=template&id=c842f3b4"
import script from "./AddChecklistModel.vue?vue&type=script&lang=js"
export * from "./AddChecklistModel.vue?vue&type=script&lang=js"
script.render = render

export default script